<template>
  <div class="modal">
    <div class="modal__container">
      <h1 class="modal__header">Confirm</h1>
      <p class="modal__text" v-if="modalType === 'activeModal'">
        Do you want to make user
        <strong>{{ active ? 'inactive' : 'active' }}</strong>?
      </p>
      <p class="modal__text" v-if="modalType === 'adminModal'">
        Do you want to
        <strong>{{ active ? 'remove' : 'add' }}</strong> admin privileges?
      </p>
      <div class="divider"></div>
      <div class="modal_btns">
        <div class="modal-btn__container">
          <v-btn class="elevation-0 modal-btn cancel" :color="'#DEDEDE'" @click="cancel">Cancel</v-btn>
          <v-btn class="elevation-0 modal-btn confirm" :color="'#CB201F'" @click="confirm">Confirm</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: ['active', 'modalType'],
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 100; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */

  display: flex;
  justify-content: center;
  align-items: center;

  &__container {
    border-radius: 4px;
    padding: 30px;
    background: #fff;
    color: #000;
    width: 400px;
  }

  h1,
  p {
    color: #212121 !important;
    font-family: Heebo;
    line-height: 2.1rem;
    letter-spacing: 0.124rem;
  }

  &__header {
    height: 5rem;
    font-size: 2.4rem !important;
    font-weight: bold;
    text-align: center;
    padding: 10px 0.5rem 15px 0.5rem !important;
  }

  &__text {
    text-align: center;
    padding: 0 0 1rem 0;
    font-size: 1.2rem;
  }

  .divider {
    width: 33rem;
    height: 0.1rem;
    border-bottom: 2px solid #dedede;
    margin: 0.5rem auto;
  }

  &-btn {
    font-family: Heebo;
    letter-spacing: 0.5px;
    font-size: 1.5rem;
    line-height: 24px;
    text-align: center;
    text-transform: none;
    width: 120px;

    &__container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 25px 30px 5px 30px;
    }

    &.confirm {
      color: #fff;
    }

    &.cancel {
      margin-left: 15px;
    }
  }
}
</style>

